module.exports = __webpack_public_path__ + "img/logo.0417dba3.svg";